import { mountApp } from './lib/mountApp';
import { Home } from './pages/Home';

mountApp('Home', <Home />);
